import Vue from 'vue';
import Vuex from 'vuex';
import app from "./app";
import auth from "./auth";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    app
  },
  actions: {
    async resetStates({ commit }) {
      commit("auth/reset");
      commit("app/reset");
    }
  },
  strict: process.env.NODE_ENV !== "production"
});